module.exports = __webpack_public_path__ + "static/media/collapse-icon.54a7577a.svg";